import React from 'react';
import RAQForm from '../components/forms/RAQForm';
import './Views.css';

const RAQ = ({ isOpen, onToggleRAQ }) => {
    return (
        <div className={`raq-slide ${isOpen ? 'open' : 'closed'}`}>
            <div className='left-clm'>
                <h1>"</h1>
                <p className='rRev'>Michael and his team did a really great job with my Tesla home charge station installation</p>
                <div className='revContainer'>
                    <div><img src="" alt=''/></div>
                    <div className='clientInfo'>
                        <p className='rName'>Gerald Shumacher</p>
                        <p className='rLocation'>Henrico, VA</p>
                    </div>
                    <div className='trust'>
                        <p>Trusted by:</p>
                        <div className='clientele'>
                            <ul>
                                <li className='cl-one'>
                                    {/* Styled Within main styling */}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className='right-clm'>
                <RAQForm onToggleRAQ={onToggleRAQ}/>
            </div>
        </div>
    );
}

export default RAQ;